"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMScopeManager = void 0;
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../container/ServiceIdentifiers");
const IVMVariableCollector_1 = require("../../interfaces/vm-transformers/analyzers/IVMVariableCollector");
const VMConstants_1 = require("../VMConstants");
const NodeGuards_1 = require("../../node/NodeGuards");
let VMScopeManager = class VMScopeManager {
    constructor(variableCollector) {
        this.variableCollector = variableCollector;
    }
    enterParametersTDZ(context, remainingParams) {
        context.parametersInTDZ.clear();
        for (const paramName of remainingParams) {
            context.parametersInTDZ.add(paramName);
        }
    }
    exitParameterTDZ(context, paramName) {
        context.parametersInTDZ.delete(paramName);
    }
    clearParametersTDZ(context) {
        context.parametersInTDZ.clear();
    }
    enterLocalsTDZ(context, varNames) {
        for (const varName of varNames) {
            context.localVariablesInTDZ.add(varName);
        }
    }
    exitLocalTDZ(context, varName) {
        context.localVariablesInTDZ.delete(varName);
    }
    checkTDZ(context, varName) {
        if (context.parametersInTDZ.has(varName)) {
            return { inTDZ: true, type: 'parameter' };
        }
        if (context.localVariablesInTDZ.has(varName)) {
            return { inTDZ: true, type: 'local' };
        }
        return { inTDZ: false, type: null };
    }
    isInTDZWithBypass(context, varName) {
        var _a;
        if (!context.localVariablesInTDZ.has(varName)) {
            return false;
        }
        if ((_a = context.perIterationLoopVars) === null || _a === void 0 ? void 0 : _a.has(varName)) {
            return false;
        }
        return true;
    }
    checkShadowing(context, varName, options) {
        var _a;
        const { variableKind, hasBlockScopedDecl = false } = options;
        const noShadow = { shadows: false, action: 'none' };
        if (context.parentContext) {
            const parent = context.parentContext;
            if (parent.localVariables.has(varName)) {
                return {
                    shadows: true,
                    shadowedType: 'local',
                    action: hasBlockScopedDecl ? 'createChildEnv' : 'useScoped'
                };
            }
            if (parent.envVars.has(varName)) {
                return {
                    shadows: true,
                    shadowedType: 'env',
                    action: hasBlockScopedDecl ? 'createChildEnv' : 'useScoped'
                };
            }
            if (parent.parameters.has(varName) && !parent.parametersInTDZ.has(varName)) {
                return {
                    shadows: true,
                    shadowedType: 'parameter',
                    action: hasBlockScopedDecl ? 'createChildEnv' : 'useScoped'
                };
            }
        }
        if (context.parameters.has(varName)) {
            return {
                shadows: true,
                shadowedType: 'parameter',
                action: hasBlockScopedDecl ? 'createChildEnv' : 'useScoped'
            };
        }
        if (context.envVars.has(varName)) {
            return {
                shadows: true,
                shadowedType: 'env',
                action: hasBlockScopedDecl ? 'createChildEnv' : 'useScoped'
            };
        }
        if (context.localVariables.has(varName)) {
            return {
                shadows: true,
                shadowedType: 'local',
                action: hasBlockScopedDecl ? 'useScoped' : 'usePlain'
            };
        }
        if ((_a = context.perIterationLoopVars) === null || _a === void 0 ? void 0 : _a.has(varName)) {
            return {
                shadows: true,
                shadowedType: 'perIteration',
                action: 'useScoped'
            };
        }
        for (const existingVar of context.localVariables.keys()) {
            const baseName = existingVar.split('$$')[0];
            if (baseName === varName && existingVar !== varName) {
                return {
                    shadows: true,
                    shadowedType: 'local',
                    action: 'useScoped'
                };
            }
        }
        if (context.functionName && varName === context.functionName) {
            const hasLocalShadow = context.localVariables.has(varName);
            if (!hasLocalShadow) {
                return {
                    shadows: true,
                    shadowedType: 'nfe',
                    action: variableKind === 'var' ? 'usePlain' : 'useScoped'
                };
            }
        }
        return noShadow;
    }
    isDeclaredInParent(context, varName) {
        let currentContext = context.parentContext;
        while (currentContext) {
            if (currentContext.parameters.has(varName) && !currentContext.parametersInTDZ.has(varName)) {
                return true;
            }
            if (currentContext.localVariables.has(varName)) {
                return true;
            }
            if (currentContext.envVars.has(varName)) {
                return true;
            }
            const renamedPattern = `${varName}$$`;
            for (const param of currentContext.parameters.keys()) {
                if (param.startsWith(renamedPattern) && !currentContext.parametersInTDZ.has(param)) {
                    return true;
                }
            }
            currentContext = currentContext.parentContext;
        }
        return false;
    }
    enterBlock(context) {
        context.blockScopeDepth++;
        if (!context.activeBlockScopes) {
            context.activeBlockScopes = new Set();
        }
        return {
            depth: context.blockScopeDepth,
            scopesBefore: new Set(context.activeBlockScopes),
            varsAdded: []
        };
    }
    exitBlockWithHandle(context, handle) {
        if (context.activeBlockScopes) {
            for (const scopedKey of context.activeBlockScopes) {
                if (!handle.scopesBefore.has(scopedKey) && scopedKey.endsWith(`$$${handle.depth}`)) {
                    context.activeBlockScopes.delete(scopedKey);
                }
            }
        }
        if (context.activeBlockScopes) {
            for (const scopedKey of handle.varsAdded) {
                context.activeBlockScopes.delete(scopedKey);
            }
        }
        context.blockScopeDepth--;
    }
    trackBlockVariable(handle, scopedKey) {
        handle.varsAdded.push(scopedKey);
    }
    exitBlock(context, varsToCleanup) {
        const depth = context.blockScopeDepth;
        if (varsToCleanup && context.activeBlockScopes) {
            for (const varName of varsToCleanup) {
                const scopedKey = this.getScopedKey(varName, depth);
                context.activeBlockScopes.delete(scopedKey);
                context.localVariablesInTDZ.delete(varName);
            }
        }
        context.blockScopeDepth--;
    }
    registerBlockVariable(context, varName, kind) {
        const depth = context.blockScopeDepth;
        const scopedKey = this.getScopedKey(varName, depth);
        const localIndex = context.localVariables.size;
        context.localVariables.set(scopedKey, localIndex);
        if (!context.activeBlockScopes) {
            context.activeBlockScopes = new Set();
        }
        context.activeBlockScopes.add(scopedKey);
        context.variableScopes.set(scopedKey, { depth, index: localIndex });
        if (kind === 'const') {
            context.constLocalVariables.add(localIndex);
        }
        return { scopedKey, localIndex, depth };
    }
    getScopedKey(varName, depth) {
        return (0, VMConstants_1.getScopedVariableName)(varName, depth);
    }
    isScopedVarActive(context, scopedKey) {
        if (!context.activeBlockScopes) {
            return false;
        }
        return context.activeBlockScopes.has(scopedKey);
    }
    registerPerIterationVar(context, varName, scopedKey) {
        if (!context.perIterationLoopVars) {
            context.perIterationLoopVars = new Set();
        }
        if (!context.perIterationVarScopedKeys) {
            context.perIterationVarScopedKeys = new Set();
        }
        context.perIterationLoopVars.add(varName);
        context.perIterationVarScopedKeys.add(scopedKey);
    }
    isPerIterationVar(context, varName) {
        var _a, _b;
        return (_b = (_a = context.perIterationLoopVars) === null || _a === void 0 ? void 0 : _a.has(varName)) !== null && _b !== void 0 ? _b : false;
    }
    isPerIterationScopedKey(context, scopedKey) {
        var _a, _b;
        return (_b = (_a = context.perIterationVarScopedKeys) === null || _a === void 0 ? void 0 : _a.has(scopedKey)) !== null && _b !== void 0 ? _b : false;
    }
    enterEnv(context, builder, skipGetEnv = false) {
        const handle = {
            previousDepth: context.envDepth
        };
        if (!skipGetEnv) {
            builder.getEnv();
        }
        builder.createEnv();
        context.envDepth++;
        return handle;
    }
    exitEnv(context, builder, handle) {
        builder.restoreParentEnv();
        context.envDepth--;
        if (context.envDepth !== handle.previousDepth) {
        }
    }
    pushBreakEnvDepth(context) {
        context.breakEnvDepths.push(context.envDepth);
    }
    popBreakEnvDepth(context) {
        context.breakEnvDepths.pop();
    }
    pushContinueEnvDepth(context) {
        context.continueEnvDepths.push(context.envDepth);
    }
    popContinueEnvDepth(context) {
        context.continueEnvDepths.pop();
    }
    getEnvDepth(context) {
        return context.envDepth;
    }
    scanForLexicalDeclarations(blockBody) {
        return this.variableCollector.scanForLexicalDeclarations(blockBody);
    }
    collectLexicalDeclarations(node) {
        if (NodeGuards_1.NodeGuards.isBlockStatementNode(node)) {
            return this.variableCollector.scanForLexicalDeclarations(node.body);
        }
        if (NodeGuards_1.NodeGuards.isProgramNode(node)) {
            return this.variableCollector.scanForLexicalDeclarations(node.body);
        }
        return new Set();
    }
};
exports.VMScopeManager = VMScopeManager;
exports.VMScopeManager = VMScopeManager = __decorate([
    (0, inversify_1.injectable)(),
    __param(0, (0, inversify_1.inject)(ServiceIdentifiers_1.ServiceIdentifiers.IVMVariableCollector)),
    __metadata("design:paramtypes", [typeof (_a = typeof IVMVariableCollector_1.IVMVariableCollector !== "undefined" && IVMVariableCollector_1.IVMVariableCollector) === "function" ? _a : Object])
], VMScopeManager);
